import { NextPage } from 'next';
import React, { useState } from 'react';
import { ElementType, useEffect } from 'react';
import api from 'services/api';
import { Coin } from 'store/Coin/types';

interface PassedProps {
  coin: Coin | null;
}

interface InitialProps {
  coin: Coin | null;
}

interface Props {
  coin: Coin | null;
}

const withContainer = (WrappedComponent: ElementType<PassedProps>) => {
  const MarketsDetail: NextPage<Props & InitialProps, InitialProps> = (
    props,
  ) => {
    const [coin, setCoin] = useState(props.coin);

    useEffect(() => {
      if (!coin) {
        return;
      } else if (typeof window !== 'undefined') {
        return;
      }

      const interval = setInterval(async () => {
        const response = await api.get(`/coins/${coin.id}`, {});
        if (response.status === 200) {
          setCoin(response.data.data);
        }
      }, 60 * 1000);

      return () => {
        clearInterval(interval);
      };
    }, [coin]);

    return <WrappedComponent coin={coin} />;
  };

  MarketsDetail.getInitialProps = async (ctx) => {
    const { code, slug } = ctx.query;

    const response = await api.get('/coins/by-code-and-slug', {
      params: {
        code,
        slug,
      },
    });
    if (response.status === 404) {
      ctx
        .res!.writeHead(302, {
          Location: '/en/crypto',
        })
        .end();

      return {
        coin: null,
      };
    }

    return {
      coin: response.data.data,
    };
  };

  return MarketsDetail;
};

export default withContainer;
